export default __webpack_public_path__ + "dd4a0d1e49dff74b88e143a86acbdbdd.webp";